<template>
  <section class="inquiry" id="inquiry">
    <div class="card-banner container-md">
      <h2 class="sr-only">도입문의</h2>
      <div class="inquiry-list">
        <dl class="inquiry-item1" v-intersect>
          <dt>도입문의</dt>
          <dd>
            <span class="item">
                <img class="icon" src="../../assets/pc_barocare_new/ico-phone.png" alt="전화번호">
                070-8655-2300
            </span>
            <span class="item">
                <img class="icon" src="../../assets/pc_barocare_new/ico-clock.png" alt="영업시간">
                평일 09시 - 18시
            </span>
            <img class="symbol" src="../../assets/pc_barocare_new/img-inquiry1.png" alt="">
          </dd>
        </dl>
        <a class="inquiry-item2" href="http://pf.kakao.com/_xoDxeJG/chat" target="_blank" title="새창" v-intersect>
          <dl>
            <dt>카카오 채널 추가<br> 바로가기</dt>
            <dd>
              <span class="link">                
                채널 바로가기
                <img class="icon" src="../../assets/pc_barocare_new/ico-plus.png" alt="+">
              </span>
              <img class="symbol" src="../../assets/pc_barocare_new/img-kakao-channel.png" alt="">
            </dd>
          </dl>
        </a>
        <dl class="inquiry-item3" v-intersect>
          <dt>바로돌봄 카카오톡 1:1 채팅 상담<br> 바로가기</dt>
          <dd>
              휴대폰 카메라로 우측 QR 코드를 스캔하세요
              <img class="symbol" src="../../assets/pc_barocare_new/img-kakao-qrcode.png" alt="QR코드 : http://pf.kakao.com/_xoDxeJG/chat">
          </dd>
        </dl>
      </div>
    </div>
    <div class="faq container">
      <h3 class="title text-xl" v-intersect>자주 묻는 질문</h3>
      <dl class="faq-list" v-intersect>
        <dt :class="{ 'opened': openIndex === 0 }">
          <button type="button" @click="toggle(0)">
            <span class="bullet">Q</span>
            <span class="subject">비대면진료가 법적으로 가능한가요?</span>
          </button>
        </dt>
        <dd v-show="openIndex === 0">
          <ul>
            <li>
              12월 15일 시행 비대면진료 시범사업 보완방안 주요 내용에 따라
              의료취약계층(장기요양등급인정자, 등록장애인, 도서산간벽지
              거주자)는 비대면진료 및 약배달이 가능합니다.
            </li>
            <li>12월 15일 시행 비대면진료 시범사업 보완방안 주요 내용
              <ul>
                <li>
                  휴일이나 야간(오후 6시 이후)에는 연령과 진료 경험에 관계 없이
                  초진이 가능하며, 처방도 가능
                </li>
                <li>
                  6개월 이내 대면진료 경험과 다니던 의료기관 의사의 판단에 따라
                  질환과 관계없이 비대면진료 가능
                </li>
                <li>
                  의료기관에서 약국으로 처방전 직접 전송. 앱을 이용하여 전달 시
                  환자가 원본 처방전 다운로드 불가
                </li>
              </ul>
            </li>
          </ul>
        </dd>
        <dt :class="{ 'opened': openIndex === 1 }">
          <button type="button" @click="toggle(1)">
            <span class="bullet">Q</span>
            <span class="subject">모든 진료를 비대면으로 볼 수 있나요?</span>
          </button>
        </dt>
        <dd v-show="openIndex === 1">
          <ul>
            <li>
              대부분의 경증질환과 만성질환은 비대면진료로 진찰 및 처방이
              가능합니다. 그러나 혈액 채취, MRI/CT 등의 정밀 검진이 필요하거나
              환부에 직접적인 처치를 해야하는 피부과 진료, 주사제 처방이 필요한
              진료 등은 비대면 진료에 적합하지 않으므로 대면 진료가 필요합니다.
              해당 경우에는 대면을 통한 초진 후 대면진료와 비대면진료를
              병행함으로써 환자의 병원 방문 부담을 덜어드릴 수 있습니다. 단,
              당뇨, 골다공증 등 가정용 주사제를 이용하는 경우 해당 약은
              비대면으로 처방 및 약품 배달이 가능합니다.
            </li>
          </ul>
        </dd>
        <dt :class="{ 'opened': openIndex === 2 }">
          <button type="button" @click="toggle(2)">
            <span class="bullet">Q</span>
            <span class="subject"
              >기존에 먹던 약과 동일한 약을 처방받을 수 있나요?</span
            >
          </button>
        </dt>
        <dd v-show="openIndex === 2">
          <ul>
            <li>
              보건복지부에서 지정한 마약류 및 오남용 우려 의약품(주로 항정신성의약품, 수면제, 진정제)을 제외한 약(<a
                href="https://soldoc.notion.site/04a69ce6f48542199d4d14511544c2be?pvs=4" target="_blank" title="새 창"
                >클릭하여 이동</a
              >)들은 모두 처방 가능합니다.
            </li>
            <li>
              도네페질, 메만틴, 콜린알포세레이 등 치매 관련 약품은 비대면 처방이 가능합니다. 단, 1년 주기로 치매 검사 후 처방이 가능하므로, 병원이 바뀌는 경우 재검사를 요청할 수 있기에 제한이 있을 수 있습니다. 바로돌봄 제휴 병원에서 비대면 치매 검사 및 약 처방이 가능합니다.
            </li>
            <li>
              약 처방은 의사의 고유 권한이기 때문에 환자가 일방적으로 요구할 수는 없습니다. 다만, 진료 예약 시 현재 복용중인 약 목록을 첨부하신 후, 진료보실 때 의사선생님께 해당 약으로 처방이 가능한지 문의해보실 수 있습니다.
            </li>
          </ul>
        </dd>
        <dt :class="{ 'opened': openIndex === 3 }">
          <button type="button" @click="toggle(3)">
            <span class="bullet">Q</span>
            <span class="subject"
              >비대면으로 의사 진료를 받으면 본인부담금에서 차이가 있는 것
              아닌가요?</span
            >
          </button>
        </dt>
        <dd v-show="openIndex === 3">
          <ul>
            <li>
              결론부터 말씀드리면, 대부분의 경우 비대면진료 초진 시 1회에 한해
              대면진료 대비 2,500원의 진료비 차액이 발생하며, 재진 시 차액은
              100원입니다. 65세 이상 어르신은 요양급여비용총액 15,000원 이하의
              경우 대부분의 경우 대면진료와 동일하게 정액으로 1,500원을 부담하게
              됩니다. 15,000원 초과 시에도 대면진료와 동일하게
              요양급여비용총액의 10% 등 총액의 구간에 따라 정해진 비율로
              본인부담금을 납부하게 되는데, 이 경우 비대면진료 가산금이 있기
              때문에 소액 차이가 발생할 수 있습니다.
            </li>
            <li>
              초진진찰료 본인부담금 차액 2,500원 발생
              <ul>
                <li>
                  대면진료 시 의원 초진진찰료 17,610원 ⇒ 요양급여비용 총액
                  17,610원
                  <ul>
                    <li>10% 본인부담률 적용한 1,700원 본인부담</li>
                  </ul>
                </li>
                <li>
                  비대면진료 시 의원 초진진찰료 17,610원 + 비대면진료 시범사업
                  관리료 3,720원 ⇒ 요양급여비용 총액 21,330원
                  <ul>
                    <li>
                      20,000원 초과 ~ 25,000원 이하 구간 20% 본인부담률 적용한
                      4,200원 본인부담
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              재진진찰료 본인부담금 차액 100원 발생
              <ul>
                <li>
                  대면진료 시 의원 재진진찰료 12,590원 ⇒ 요양급여비용 총액
                  12,590원
                  <ul>
                    <li>15,000원 이하 본인부담률 적용한 1,500원 본인부담</li>
                  </ul>
                </li>
                <li>
                  비대면진료 시 의원 재진진찰료 12,590원 + 비대면진료 시범사업
                  관리료 3,720원 ⇒ 요양급여비용 총액 16,310원
                  <ul>
                    <li>
                      15,000원 초과 20,000원 이하 구간 10% 본인부담률 적용한
                      1,600원 본인부담
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              위 내용은 2024년 수가 기준, 공휴일이 아닌 평일, 야간이 아닌 주간,
              만 65세 이상 어르신 기준으로 설명드린 내용입니다.
              의료급여수급권자의 경우 진료비 1,000원, 조제비 500원이 동일하게
              적용되고, 건강생활유지비 차감도 대면진료와 동일하게 이뤄집니다.
              아울러, 중증치매, 희귀질환 등 산정특례에 해당되는 경우 계산이
              달라질 수 있으나 고혈압, 당뇨, 고지혈증 등 대부분의 경우는
              비산정특례에 해당됩니다. 자세한 사항은 건강보험심사평가원
              홈페이지에 안내된 65세 이상 의원급 본인일부부담률 및 부담액
              안내(<a
                href="https://www.hira.or.kr/dummy.do?pgmid=HIRAA030056020110" target="_blank" title="새 창"
                >클릭하여 이동</a
              >)를 참조하여주시기 바랍니다.
            </li>
          </ul>
        </dd>
        <dt :class="{ 'opened': openIndex === 4 }">
          <button type="button" @click="toggle(4)">
            <span class="bullet">Q</span>
            <span class="subject"
              >비대면진료를 통한 조제 시에 조제비(약값)에서 차이가 있는 것
              아닌가요?</span
            >
          </button>
        </dt>
        <dd v-show="openIndex === 4">
          <ul>
            <li>
              대체 조제(동일 성분 다른 약)을 받으면, 약 값이 소액 차이나는
              경우가 있으며, 비대면조제 시범사업 관리료 1,020원 가산에 따른
              본인부담액 산정 구간의 변경 시 몇 백원 수준의 차액이 발생할 수
              있습니다. 대체로 본인부담률이 30%이므로 대면진료와 비교했을 때
              추가되는 금액은 1,020원의 30%인 300원 수준으로 예상됩니다.
              구체적으로 설명드리면 「국민건강보험법 시행규칙」별표4에 따라
              본인부담률이 적용되며, 65세 이상이며 처방전에 의하여 의약품을
              조제받은 경우에 요양급여비용총액이 1만원 이하인 경우의
              본인부담액은 1,200원이며, 요양급여비용총액이 1만원을 초과하는
              경우의 본인부담액은 요양급여비용총액의 30%입니다. 자세한 사항은
              약을 수령하신 약국에 문의해주세요.
            </li>
          </ul>
        </dd>
      </dl>
    </div>
  </section>
</template>

<script>
export default {
    data() {
        return {
            openIndex: 0 // 초기에 아무 항목도 열려있지 않음
        };
    },
    methods: {
        toggle(index) {
            // 이미 열려 있는 항목을 클릭하면 모두 닫힘
            this.openIndex = this.openIndex === index ? -1 : index;
        }
    },
    directives: {
        intersect: {
            // 요소가 DOM에 삽입될 때 호출됩니다.
            inserted(el) {
                const options = {
                    root: null, // 뷰포트를 기본값으로 설정
                    rootMargin: '0px', // 뷰포트의 마진은 0
                    threshold: 0.1 // 10%가 보일 때 콜백이 실행
                };
                const callback = (entries, observer) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            el.classList.add('visible');
                        } else {
                            el.classList.remove('visible');
                        }
                    });
                };
                const observer = new IntersectionObserver(callback, options);
                observer.observe(el); // 해당 요소를 관찰 시작
            }
        }
    },
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/pc_barocare_new/Inquiry.vue